(function () {

    'use strict';

    /**
     * Initiates the fixed header
     */
    const FixedHeader = function (element) {

        // The element itself
        this.element = element;

        // The scroll offset which needs to be reached to take effect
        this.offset = 300;

        // The header position
        this.position = window.getComputedStyle(this.element).position;

        this.fixateHeader = this.fixateHeader.bind(this);

        // Fixate the header not only on scroll. E.g. page refresh
        this.fixateHeader();

        this.initiateListener();
    };

    /**
     * Initiates the event listener
     */
    FixedHeader.prototype.initiateListener = function () {
        document.addEventListener('scroll', this.fixateHeader);
    }

    /**
     * Fixate the header when scroll offset is reached
     */
    FixedHeader.prototype.fixateHeader = function () {

        if((document.documentElement.scrollHeight - window.innerHeight) < this.offset) {
            // Decrease the offset when the offset cannot possibly be reached
            this.offset = 300;
        }

        if (this.position === 'absolute') {

            if (window.scrollY >= this.offset)  {

                if (!this.element.classList.contains('position-fixed')) {
                    this.element.classList.replace('position-absolute', 'position-fixed');
                }

            } else {
                this.element.classList.replace('position-fixed', 'position-absolute');
            }

        } else {

            if (window.scrollY >= this.offset)  {

                if (!this.element.classList.contains('position-fixed')) {
                    this.element.classList.replace('position-relative', 'position-fixed');
                }

            } else {
                this.element.classList.replace('position-fixed', 'position-relative');
            }
        }
    }

    const headers = document.getElementsByClassName('js-fixed-header');

    for (const header of headers) {
        new FixedHeader(header);
    }
}());